<template>
  <div class="wrp p-4" v-loading="isLoading" v-if="hasMammo">
    <div class="flex justify-between items-center mb-2">
      <h2>Breast-Expert 18: {{ $t("side_menu.lbl_mammo") }}</h2>
      <div class="border rounded-full p-2 cursor-pointer" @click="goBack">
        <svg data-v-2558e796 width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="cursor-pointer">
          <path data-v-2558e796 d="M6 18.4998L17.9998 6.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path data-v-2558e796 d="M17.9998 18.4998L6 6.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
    <div class="rounded-xl bg-white p-3">
      <RISHeader @setIsLoading="setIsLoading" />
      <div class="row mb-3">
        <div class="col-lg-6">
          <h3>
            <strong>{{ $t("title.lbl_right_breast") }}</strong>
          </h3>
          <div class="row mb-2 align-items-center" v-for="(item, index) in filesR" :key="item.file_uid">
            <div class="col-lg-2 font-bold">{{ $t(item.title) }}</div>
            <div class="col-lg-10">
              <label class="w-full">
                <input class="form-control border" type="file" accept=".dcm, application/dicom" @change="e => handleChangeFile(e, index, 'filesR')" />
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <h3>
            <strong>{{ $t("title.lbl_left_breast") }}</strong>
          </h3>
          <div class="row mb-2 align-items-center" v-for="(item, index) in filesL" :key="item.file_uid">
            <div class="col-lg-2 font-bold">{{ $t(item.title) }}</div>
            <div class="col-lg-10">
              <label class="w-full">
                <input class="form-control border" type="file" accept=".dcm, application/dicom" @change="e => handleChangeFile(e, index, 'filesL')" />
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <h3>
          <strong>{{ $t("title.doctor_conclusion") }}</strong>
        </h3>
        <div>
          <textarea v-model="analysis_diagnose" class="form-control border" rows="3"></textarea>
        </div>
      </div>
      <div class="mb-3">
        <h3>
          <strong>{{ $t("title.lbl_description_of_lesion_image") }}</strong>
        </h3>
        <div>
          <textarea v-model="diagnose" class="form-control border" rows="6"></textarea>
        </div>
      </div>
      <div class="text-center">
        <button class="btn btn-primary" @click="handleSubmit">
          <span>{{ $t("lbl_send") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '@/utils/appUtils'
import { mixinHasFeatures } from '@/utils/mixinHasFeatures'
import { v4 as uuid } from 'uuid'
import RISHeader from '../Common/RISHeader'

export default {
  name: 'AddMammo',
  mixins: [mixinHasFeatures],
  components: { RISHeader },
  data () {
    return {
      isLoading: true,
      filesBase64: [],
      files: [],
      filesL: [],
      filesR: [],
      patientId: Number(this.$route.params?.id) || null,
      diagnose: '',
      analysis_diagnose: '',
      appUtils
    }
  },
  mounted () {
    this.handleDefaultFiles()
  },
  watch: {
    '$route.params': {
      async handler (data) {
        const { id } = data
        if (!Number.isNaN(Number(id))) {
          this.patientId = id
        }
      },
      deep: true
    }
  },
  methods: {
    getSubFileType (type) {
      switch (type) {
        case 1:
        case 2:
          return 'R'
        case 3:
        case 4:
          return 'L'
        default:
          return ''
      }
    },
    handleDefaultFiles () {
      this.files = [...Array(4).keys()].map((_, i) => ({
        file_uid: uuid(),
        title: i % 2 ? 'CC' : 'MLO',
        sub_file_type: i + 1
      }))
      this.filesR = []
      this.filesL = []
      // eslint-disable-next-line no-unused-expressions
      this.files?.map(file => {
        if ([1, 2].includes(file?.sub_file_type)) {
          this.filesR.push(file)
        } else if ([3, 4].includes(file?.sub_file_type)) {
          this.filesL.push(file)
        }
      })
    },
    setIsLoading (value) {
      this.isLoading = value
    },
    goBack () {
      this.$router
        .replace({
          name: 'MammoDicomPage'
        })
        .catch(() => {})
    },
    handleChangeFile (e, index, fileType) {
      const self = this
      const file = e.target.files?.[0]
      if (!file) return

      appUtils.fileToBase64(file, function (base64String) {
        self[fileType][index] = {
          ...self[fileType][index],
          value: file,
          base64: base64String
        }
      })
    },
    async handleSubmit () {
      const self = this

      try {
        self.isLoading = true
        self.filesBase64 = [...self.filesR, ...self.filesL]

        let preDataInfo = {
          health_profile_id: null,
          medical_record_id: null,
          patient_id: self.patientId,
          diagnose: self.diagnose || '',
          diagnosed_by: self.$user?.id,
          analysis_diagnose: self.analysis_diagnose,
          analysed_at: null,
          requested_at: Date.now(),
          ws_id: self.$clinicId
        }
        let file_content = []
        let viewer_url = ''

        await Promise.all(
          self.filesBase64.map(async file => {
            const fileInfo = {
              title: file?.title,
              sub_file_type: file?.sub_file_type
            }
            if (!file || !file?.base64) {
              file_content.push({
                ...fileInfo
              })
              return
            }

            const data = {
              fileContent: file?.base64
            }

            const res = await self.$rf.getRequest('RisRequest').uploadMamoDicom(data)

            if (!res.data) return

            const fileUID = res.data?.sopInstanceUid
            if (!fileUID) {
              self.$message({
                message: `File ${self.getSubFileType(file?.sub_file_type)}-${file?.title} tải lên không thành công!`,
                type: 'error'
              })
              return
            }

            file.fileUID = fileUID
            file_content.push({
              ...fileInfo,
              fileUID
            })
            preDataInfo.study_id = res.data?.studyUid
            viewer_url = res.data?.viewer_url || ''
          })
        )

        preDataInfo = {
          ...preDataInfo,
          file_content,
          viewer_url
        }

        if (!file_content.length || self.filesBase64?.some(file => file?.base64 && !file?.fileUID)) {
          return
        }

        const result = await self.handleCreateNewMammoCase(preDataInfo)
        if (!result) return

        self.$message({
          message: 'Thêm mới trường hợp thành công!',
          type: 'success'
        })

        self.$router
          .replace({
            name: 'DetailMammoDicomPage',
            params: {
              id: result.id
            }
          })
          .catch(() => {})

        self.filesBase64 = []
        self.handleDefaultFiles()
      } catch (error) {
        console.log(error)
        self.$message({
          message: 'Đã xảy ra lỗi khi tải file lên hệ thống!',
          type: 'error'
        })
      } finally {
        self.isLoading = false
      }
    },
    async handleCreateNewMammoCase (data) {
      try {
        const res = await this.$rf.getRequest('RisRequest').createNewMammoCase(data)
        return res.data
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
